import { render, staticRenderFns } from "./TrainingArchive.vue?vue&type=template&id=ab0f0ab8&"
import script from "./TrainingArchive.vue?vue&type=script&lang=js&"
export * from "./TrainingArchive.vue?vue&type=script&lang=js&"
import style0 from "./TrainingArchive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports